/**
 * Auto Template Component
 *
 * Automatically imports and initializes JavaScript/TypeScript modules
 * from the /components directory based on DOM element IDs.
 */

type ComponentModule = {
  [key: string]: {
    [key: string]: () => void
  }
}

const autoTemplateComponent = async (): Promise<void> => {
  try {
    // Import all modules from the /components directory if they exist
    const components = (await import(
      '../../../components/**/*.{ts,js}'
    )) as ComponentModule

    if (components) {
      const allComponents = Object.keys(components)

      allComponents.forEach((component) => {
        const element = document.getElementById(`js-${component}`)

        if (element !== null) {
          const mod = components[component]?.[component]

          if (mod && typeof mod === 'function') {
            mod()
          }
        }
      })
    }
  } catch (error) {
    // No components found or import failed - this is expected if no component JS exists
    if (import.meta.env?.DEV) {
      console.debug('No component modules found or failed to load:', error)
    }
  }
}

export default autoTemplateComponent
